import styled, { css } from "styled-components";

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 0.5rem;
  padding: 0.7rem;
`;

export const Avatar = styled.div``;
export const Name = styled.p`
  font-weight: 700;
  font-size: 1.4rem;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  * {
    cursor: pointer;
  }
`;

export const BreadCrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  font-weight: 700;
  font-size: 1.6rem;
`;

export const BreadCrumbItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 0.5rem;
  padding: 0.7rem;
  font-size: 1.1rem;
  background-color: ${({ theme }) => theme.colors.gray100};
  color: ${({ theme }) => theme.colors.gray700};

  a {
    color: inherit;
    text-decoration: none;
  }
`;

export const Logo = styled.img.attrs({
  src: "/images/logo-dark.svg",
  title: "Voltar para tela inicial",
})`
  height: 2.9rem;
  transition: 0.3s;
  opacity: 0.7;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;

export const Container = styled.div`
  ${({ open }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2rem;
    width: ${open ? `calc(100% - 25rem)` : `calc(100% - 9.5rem)`};

    margin-right: 0;
    margin-left: auto;
    transition: 0.3s;

    ${open &&
    css`
      ${Logo} {
        opacity: 0;
        visibility: hidden;
        display: none;
      }
    `}

    ${!open &&
    css`
      ${BreadCrumb} {
        position: relative;

        &:before {
          content: "";
          position: absolute;
          top: 50%;
          left: -1.6rem;
          transform: translateY(-50%);
          width: 0.1rem;
          height: 2rem;
          background-color: ${({ theme }) => theme.colors.disabled};
        }
      }
    `}
  `}
`;
